import { useEffect } from 'react'
import { FormikProps } from 'formik'

// Scrolls to and focuses the first Formik error field on submit.

export function useScrollToFormikError<T>(formik: FormikProps<T>) {
  useEffect(() => {
    const errorKeys = Object.keys(formik.errors)

    const shouldScrollToError =
      formik.isSubmitting && !formik.isValidating && errorKeys.length > 0

    if (!shouldScrollToError) return

    const errorElement = document.querySelector(
      `[name="${errorKeys[0]}"]`
    ) as HTMLElement

    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      setTimeout(() => {
        errorElement.focus()
      }, 500)
    }
  }, [formik.errors, formik.isSubmitting, formik.isValidating])
}
